<div class="loading-container" [class.appLoading]="sectionLoading === undefined" [class.sectionLoading]="sectionLoading !== undefined">
  <div class="loading-spinner">
    <i class="fas fa-sync fa-spin fa-3x"></i>
  </div>
</div>
